import React, { useEffect, useState } from "react";

import Table from "../../components/Table";
import apis from "../../apis";
import { handleCallApiError } from "../../errors";
import debounce from "../../utils/debounce";
import { PAGINATION_LIMIT } from "../../constants";
import dayjs from "dayjs";

const WorkTimeList = ({
  search,
  date,
  userId,
  paging,
  onChangePage,
  loading,
  setLoading,
}) => {
  const [histories, setHistories] = useState([]);

  const handleChangePage = (page) => onChangePage({ ...paging, page });

  const fetchContributions = async () => {
    setLoading(true);
    try {
      const [startDate, endDate] = date;
      const condition = {
        search,
        userId,
        startDate: dayjs(startDate).format("YYYY-MM-DD"),
        endDate: dayjs(endDate).format("YYYY-MM-DD"),
        limit: PAGINATION_LIMIT,
        offset: (paging.page - 1) * PAGINATION_LIMIT,
      };
      const res = await apis.history.getHistories(condition);
      setHistories(res.histories);
      onChangePage({ ...paging, total: res?.total || 0 });
    } catch (error) {
      handleCallApiError(error);
    }
    setLoading(false);
  };

  const columns = [
    {
      field: "customerName",
      title: "Khách hàng",
      align: "left",
    },
    {
      field: "serviceName",
      title: "Dịch vụ",
      align: "left",
    },
    {
      title: "Buổi",
      align: "left",
      render: (row) => (row.session < 10 ? `0${row.session}` : row.session),
    },
    {
      title: "Thời lượng",
      align: "left",
      render: (row) => `${row.serviceDuration} phút`,
    },
    {
      field: "userName",
      title: "Người phụ trách",
      align: "left",
    },
    {
      field: "creatorName",
      title: "Người tạo",
      align: "left",
    },

    {
      title: "Ngày tạo",
      align: "left",
      render: (row) => dayjs(row.createdAt).format("HH:mm DD-MM-YYYY"),
    },
  ];

  useEffect(() => {
    debounce(fetchContributions, 500)(search);
  }, [paging.page, search, date, userId]);

  return (
    <Table
      data={histories}
      columns={columns}
      total={paging.total}
      page={paging.page}
      loading={loading}
      onChangePage={handleChangePage}
      showNumber={true}
    />
  );
};

export default WorkTimeList;
